import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import { FollowUpProvider } from './context/FollowUpContext';
import { TenantProvider } from './context/TenantContext';
// import LanguageSwitcher from './components/LanguageSwitcher';
import SessionTimer from './components/SessionTimer';
import ProxyModeBanner from './components/ProxyModeBanner';
// import DraftRestorePrompt from './components/DraftRestorePrompt';
import SEOHead from './components/SEOHead';
import FollowUpEntry from './Pages/FollowUpEntry';
import FollowUpOTPVerification from './Pages/FollowUpOTPVerification';
import FollowUpNewIssues from './Pages/FollowUpNewIssues';
import FollowUpModuleSelection from './Pages/FollowUpModuleSelection';
import FollowUpSteps from './Pages/FollowUpSteps';
import FollowUpReview from './Pages/FollowUpReview';
import FollowUpSectionEdit from './Pages/FollowUpSectionEdit';
import FollowUpSuccess from './Pages/FollowUpSuccess';
import StaffDailySummary from './Pages/StaffDailySummary';
import 'react-toastify/dist/ReactToastify.css';
import './styles/followup.css';
import './styles/formPage.css';
import './styles/accessibility.css'; // WCAG 2.1 fixes - must be last

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <TenantProvider>
      <FollowUpProvider>
        <SEOHead appType="followup" />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* HIGH #1: Skip Navigation - WCAG 2.4.1 A */}
        <a href="#main-content" className="skip-link">Skip to follow-up form</a>


        {/* HIGH #8: Staff proxy entry banner */}
        <ProxyModeBanner />

        {/* HIGH #4: Session timer with auto-save */}
        <SessionTimer />

        <div id="main-content" tabIndex="-1" aria-live="polite"></div>
        <Routes>
          {/* Entry point - Patient Onboarding Details (email input) */}
          <Route path="/" element={<FollowUpEntry />} />
          <Route path="/followup" element={<FollowUpEntry />} />

          {/* OTP Verification - security gate before accessing follow-up */}
          <Route path="/verify-otp" element={<FollowUpOTPVerification />} />

          {/* New Issues page - for existing users to report any changes */}
          <Route path="/new-issues" element={<FollowUpNewIssues />} />

          {/* Module selection - legacy, redirects to review */}
          <Route path="/select" element={<Navigate to="/review" replace />} />

          {/* Edit steps - for new users */}
          <Route path="/edit" element={<FollowUpSteps />} />

          {/* Per-section edit - existing users update one section at a time */}
          <Route path="/update/:moduleId" element={<FollowUpSectionEdit />} />

          {/* Review changes */}
          <Route path="/review" element={<FollowUpReview />} />

          {/* Success page */}
          <Route path="/success" element={<FollowUpSuccess />} />

          {/* L-06: Staff daily submission summary */}
          <Route path="/staff/today" element={<StaffDailySummary />} />

          {/* Fallback - redirect to entry */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

      </FollowUpProvider>
      </TenantProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
